class HubspotButton extends HTMLElement {
  constructor() {
    super();
    this.boundClickHandler = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.boundClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClickHandler);
  }

  handleClick(event) {
    event.preventDefault();
    this.openHubspotChat();
  }

  openHubspotChat() {
    // Check if HubSpot Conversations API is loaded
    if (window.HubSpotConversations && window.HubSpotConversations.widget) {
      try {
        window.HubSpotConversations.widget.open();
        console.log('HubSpot chat widget opened');
      } catch (error) {
        console.error('Error opening HubSpot chat widget:', error);
      }
    } else {
      // HubSpot not loaded yet, wait for it
      console.log('HubSpot not loaded yet, waiting...');
      this.waitForHubspot();
    }
  }

  waitForHubspot() {
    // Listen for HubSpot ready event
    const checkInterval = setInterval(() => {
      if (window.HubSpotConversations && window.HubSpotConversations.widget) {
        clearInterval(checkInterval);
        try {
          window.HubSpotConversations.widget.open();
          console.log('HubSpot chat widget opened (after waiting)');
        } catch (error) {
          console.error('Error opening HubSpot chat widget:', error);
        }
      }
    }, 100);

    // Stop checking after 10 seconds to avoid infinite loop
    setTimeout(() => {
      clearInterval(checkInterval);
      if (!window.HubSpotConversations || !window.HubSpotConversations.widget) {
        console.warn('HubSpot chat widget failed to load after 10 seconds');
      }
    }, 10000);
  }
}

customElements.define('hubspot-button', HubspotButton);
